import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import CloseIcon from "@material-ui/icons/Close";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader/index";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { dateConvert } from "../../../../helpers/dateConvert";
import "../../../../_metronic/_assets/plugins/flaticon2/flaticon.css";

import { FaCalendarAlt, FaEnvelope, FaCheckCircle } from "react-icons/fa"
import { FcPhoneAndroid ,FcKey } from "react-icons/fc"
import { MdDescription } from "react-icons/md"

const useStyles = makeStyles({
  list: {
    width: 400,
    height: "100vh",
  },
  card: {
    margin: "30px",
  },
  pointer: {
    cursor: "pointer",
  },
});

export default function View(props) {
  const { onClose, complaint } = props;
  const {
    fullName,
    email,
    phone,
    reasonId,
    description,
    isRead,
    recordDate
  } = complaint;
  const classes = useStyles();
  const sideList = (side) => (
    <div className={classes.list} role="presentation">
      <div className="col-12 d-flex align-items-center justify-content-between py-4">
        <h1 className="h3 mb-0">Complaints details</h1>
        <CloseIcon className={classes.pointer} onClick={onClose} />
      </div>
      <Divider className="bg-dark" />
      <div className="drawer-body">
        <Card className={classes.card}>
          <CardHeader
            title="General information"
            className="bg-secondary text-dark h6 p-3"
            disableTypography
          />

          <CardHeader

            avatar={
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/Communication/Address-card.svg"
                )}
                className="icon-primary"
              />
            }

            title={fullName}
            subheader="Fullname"
            className="p-3"
          />
          <CardHeader
            avatar={

              <FaEnvelope className="icon-primary" />

            }
            title={email}
            subheader="Email"
            className="p-3"
          />
          <CardHeader
            avatar={

              <FcPhoneAndroid className="icon-primary" />

            }
            title={phone}
            subheader="Phone"
            className="p-3"
          />
          <CardHeader
            avatar={

              <FcKey className="icon-primary icon" />
            }
            title={reasonId}
            subheader="Reason Id"
            className="p-3"
          />

          <CardHeader
            avatar={

              <MdDescription className="icon-primary icon" />
            }
            title={description}
            subheader="Description"
            className="p-3"
          />

          <CardHeader
            avatar={

              <FaCheckCircle className="icon-primary icon" />
            }
            title={isRead ? "Read" : "Unread"}
            subheader="Isread"
            className="p-3"
          />
          {/* <CardHeader
            avatar={
              <FaPercent className="icon-primary icon" />

            }
            title={endDiscountPercent}
            subheader="End discount percent"
            className="p-3"
          /> */}
          <CardHeader
            avatar={
              <FaCalendarAlt className="icon-primary icon" />
            }
            title={dateConvert(recordDate)}
            subheader="Record date"
            className="p-3"
          />
        </Card>

      </div>
    </div>
  );

  return (
    <Drawer {...props} anchor="right" className="drawer--fixed">
      {sideList("right")}
    </Drawer>
  );
}
